<div class="bn-alert-notice bn-imp-notice manage-ap-imp-notice text-left mt-0 mb-4" *ngIf="!hideAlert">
  <div class="bn-icon">
    <img src="./assets/img/images/icon-warning-32.svg" alt="warning icon" />
  </div>
  <div class="bn-content">
    <div class="bn-content-text">
      <div class="imp-notice-sec">
        <div class="imp-notice-info-block mr-3">
          <div class="imp-notice-title">Important notice</div>
          <div class="manage-ap-imp-info" [innerHTML]="safeContent"></div>
        </div>
        <div class="bn-content-close">
          <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
              (click)="onClose()" />
        </div>
      </div>
    </div>
  </div>
</div>
